import { Fragment } from "react";

// Current job vacancies shown on the Careers page (/career).
// To add another job: copy one object in the "jobs" list below and edit it.
// To remove a job: delete its object from the list.
const jobs = [
  {
    id: "domiciliary-care-worker",
    title: "Domiciliary Care Worker",
    areas: "Basildon, Pitsea, Wickford and Canvey Island",
    pay: "Competitive hourly rate plus paid mileage",
    hours: "Full-time, part-time and flexible hours available",
    summary:
      "We are looking for kind, reliable people to support clients in their own homes across Basildon, Pitsea, Wickford and Canvey Island. You will help people live safely and independently, with dignity and respect. No experience is needed: we provide full, paid training.",
    duties: [
      "Supporting clients with personal care, washing and dressing",
      "Helping with medication, following care plans",
      "Preparing meals and drinks",
      "Light household tasks",
      "Companionship and a friendly face",
      "Recording visits and reporting any concerns",
    ],
    requirements: [
      "A caring, patient and reliable nature",
      "The right to work in the UK",
      "Willingness to complete an enhanced DBS check (we pay for this)",
      "Drivers with a full UK licence and access to a car are given priority",
      "No previous experience needed",
    ],
    benefits: [
      "Full paid training",
      "Enhanced DBS check paid for",
      "Mileage paid",
      "Paid holiday",
      "Workplace pension",
      "Bonuses",
      "Flexible hours to suit you",
    ],
    datePosted: "2026-09-24",
    employmentType: ["FULL_TIME", "PART_TIME"],
    localities: ["Basildon", "Pitsea", "Wickford", "Canvey Island"],
  },
];

// Structured data so Google can show the jobs in Google job search.
const jobPostingData = (job) => ({
  "@context": "https://schema.org/",
  "@type": "JobPosting",
  title: job.title,
  description: `<p>${job.summary}</p><p><strong>What you will do:</strong></p><ul>${job.duties
    .map((d) => `<li>${d}</li>`)
    .join("")}</ul><p><strong>What we are looking for:</strong></p><ul>${job.requirements
    .map((r) => `<li>${r}</li>`)
    .join("")}</ul><p><strong>Benefits:</strong></p><ul>${job.benefits
    .map((b) => `<li>${b}</li>`)
    .join("")}</ul><p>${job.pay}. ${job.hours}.</p>`,
  datePosted: job.datePosted,
  employmentType: job.employmentType,
  directApply: true,
  hiringOrganization: {
    "@type": "Organization",
    name: "Excellence Care Ltd",
    sameAs: "https://excellence-care.co.uk",
  },
  jobLocation: job.localities.map((town) => ({
    "@type": "Place",
    address: {
      "@type": "PostalAddress",
      addressLocality: town,
      addressRegion: "Essex",
      addressCountry: "GB",
    },
  })),
});

const applyFor = (title) => {
  const roleBox = document.getElementById("apply-role");
  if (roleBox) roleBox.value = title;
  const form = document.getElementById("apply-now");
  if (form) form.scrollIntoView({ behavior: "smooth", block: "center" });
};

const List = ({ icon, items }) => (
  <ul className="list-unstyled mb-0">
    {items.map((item) => (
      <li key={item} className="mb-2 d-flex">
        <i className={`bi ${icon} text-primary me-2`}></i>
        <span>{item}</span>
      </li>
    ))}
  </ul>
);

const Vacancies = () => (
  <div className="container mb-5" id="vacancies">
    <div className="text-center mb-4">
      <h5 className="position-relative d-inline-block text-primary text-uppercase">
        We're hiring
      </h5>
      <h2 className="display-6 mb-0">Current Vacancies</h2>
    </div>
    {jobs.map((job) => (
      <Fragment key={job.id}>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jobPostingData(job)) }}
        />
        <div className="bg-light p-4 p-lg-5 rounded shadow-sm">
          <div className="d-flex flex-wrap justify-content-between align-items-start mb-3">
            <div className="me-3 mb-3">
              <h3 className="mb-2">{job.title}</h3>
              <p className="mb-1">
                <i className="bi bi-geo-alt text-primary me-2"></i>
                {job.areas}
              </p>
              <p className="mb-1">
                <i className="bi bi-cash-coin text-primary me-2"></i>
                {job.pay}
              </p>
              <p className="mb-0">
                <i className="bi bi-clock text-primary me-2"></i>
                {job.hours}
              </p>
            </div>
            <button
              type="button"
              className="btn btn-primary py-3 px-5"
              onClick={() => applyFor(job.title)}
            >
              Apply Now
            </button>
          </div>
          <p className="mb-4">{job.summary}</p>
          <div className="row g-4">
            <div className="col-lg-4">
              <h5 className="mb-3">What you will do</h5>
              <List icon="bi-check-circle" items={job.duties} />
            </div>
            <div className="col-lg-4">
              <h5 className="mb-3">What we are looking for</h5>
              <List icon="bi-person-check" items={job.requirements} />
            </div>
            <div className="col-lg-4">
              <h5 className="mb-3">Benefits</h5>
              <List icon="bi-star" items={job.benefits} />
            </div>
          </div>
          <p className="mt-4 mb-0">
            Prefer to talk first? Call us on{" "}
            <a href="tel:+441268988500">01268 988500</a> or email{" "}
            <a href="mailto:info@excellence-care.co.uk">
              info@excellence-care.co.uk
            </a>
            .
          </p>
        </div>
      </Fragment>
    ))}
  </div>
);

export default Vacancies;
